<template>
    <div v-if="toggle">
        <!-- <div class="chain">
        <h3><a target="_blank" href="#">申请友链</a>友情链接</h3>
        <ul>
            <li><a href="https://sci.justscience.cn/" target="_blank">JustScience</a></li>
        </ul>
        </div> -->
        <div class="link">
            <div class="w1200">
                <el-popover>
                    <img src="../assets/wechat_qrcode.jpg" style="width: 120px;margin: auto; display: block;"/><br/>
                    广告投放请添加客服微信
                    <a rel="nofollow" slot="reference">广告服务</a>
                </el-popover>
                |
                <el-popover>
                    <div style="width: 450px; position: relative;">
                        <pre style="white-space: pre-wrap; overflow-wrap: break-word;line-height: 25px;margin: 0;"><b>网站介绍：</b>
    灯塔索引----专注于生物医药领域为广大学者、学生、医生和护士提供最快捷最有效的导航帮助。灯塔索引包含科学研究、学术发表、生物医药、分子机制、生物功能等上百个分类的优秀站点。让您的科学研究更简单更便捷。灯塔索引为您的科研、创新、梦想导航引路。


杭州百科博创生物科技有限公司
联系人：臧经理
邮箱：dotaindex@163.com
地址：杭州市拱墅区善贤路4号光阳国际4楼4086室</pre>
                        <div style="position: absolute; right: 0px; bottom: 0px;">
                            <img src="../assets/wechat_qrcode.jpg" style="width: 97px;    "/><br/>
                            请扫码添加微信
                        </div>
                    </div>
                    <a rel="nofollow" slot="reference">关于我们</a>
                </el-popover>
                |
                <el-popover>
                    <img src="../assets/qr2.jpg" style="width: 120px;margin: auto; display: block;"/><br/>
                    网站收录请关注公众号发送收录信息
                    <a rel="nofollow" slot="reference">网站收录</a>
                </el-popover>
                |
                <el-popover>
                    <img src="../assets/qr2.jpg" style="width: 120px;margin: auto; display: block;"/><br/>
                    意见反馈请关注公众号发送信息
                    <a rel="nofollow" slot="reference">意见反馈</a>
                </el-popover>
            </div>
        </div>
        <div class="foot">
            <div>Copyright © 2022-2023 灯塔索引 版权所有
                <a href="http://beian.miit.gov.cn/" target="_blank" title="网站备案" rel="external nofollow">浙ICP备19046560号-5</a><br>
                    本站部分资源收集于网络，版权归原作者所有。发布的内容若侵犯到您的权益，请联系站长删除，我们将及时处理！

            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            toggle:true
        }
    },
    watch: {
        // 如果路由有变化，会再次执行该方法
        '$route': 'changeRoute'
    },
    methods: {
        changeRoute(e) {
            if (e.path == '/cytotry') {
                this.toggle = false
            } else {
                this.toggle = true
            }
        }
    }
}
</script>
<style scoped>
div, dl, dt, dd, ul, ol, li, p, h1, h2, h3, h4, h5, h6, th, td, hr, blockquote, form, header {
    margin: 0 auto;
    padding: 0;
}

a {
    cursor: pointer;
    text-decoration: none;
    transition: all 0.3s;
    color: #666;
}

.chain { width: 1198px; background: #fff; overflow: hidden; border:#e8e8e8 1px solid; margin-top: 15px}
.chain h3 { height: 54px; line-height: 54px; color: #666; font-size: 18px; padding: 0 20px; border-bottom: #e8e8e8 1px solid;}
.chain h3 a { float: right; color: #14aab9; font-size: 14px;}
.chain ul { line-height: 44px; overflow: hidden;}
.chain ul li { width: 10%; display: inline-block; float: left; text-align: center;}
.chain ul li:last-child { background: none}
.chain ul.gray { background: #fcfcfc}
.link { width: 100%; min-width: 1200px; background: #fff; margin-top: 60px; border-top: #14aab9 2px solid}
.link div.w1200 { width: 1200px; padding: 10px 0; color: #ccc; text-align: center}
.link a { color: #666; margin: 0 10px}

.foot { width: 100%; min-width: 1200px; height: auto;background: #555;}
.foot div { width: 1200px; text-align: center; font-size: 12px; line-height: 22px;padding: 15px 0px; color: #e4e4e4; font-family: verdana;}
.foot div a { color: #e4e4e4}
</style>



// WEBPACK FOOTER //
// src/components/Foot.vue